module.exports = __webpack_public_path__ + "static/media/stamp.3b926445.png";